/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intakecontinuetooltip2Inputs */

const en_intakecontinuetooltip2 = /** @type {(inputs: Intakecontinuetooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move on to chat — you can always come back to upload more.`)
};

const pt_intakecontinuetooltip2 = /** @type {(inputs: Intakecontinuetooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avançar para o chat — pode voltar para carregar mais ficheiros depois.`)
};

/**
* | output |
* | --- |
* | "Move on to chat — you can always come back to upload more." |
*
* @param {Intakecontinuetooltip2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const intakecontinuetooltip2 = /** @type {((inputs?: Intakecontinuetooltip2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intakecontinuetooltip2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_intakecontinuetooltip2(inputs)
	return pt_intakecontinuetooltip2(inputs)
});
export { intakecontinuetooltip2 as "intakeContinueTooltip" }